export default __webpack_public_path__ + "static/media/hero-image.9dd44049.jpg";